import { CookingColumn } from '../cooking-column';
import OrdersKanbanLayout from '../orders-kanban-layout';
import PendingToAcceptColumn from '../pending-to-accept-column/';
import { PendingToDeliverColumn } from '../pending-to-deliver-column';
import { useOrdersKanbanPage } from './hooks';

function OrdersKanbanPage({ title }) {
  const { hasAutoAccept, totalColumns } = useOrdersKanbanPage();
  return (
    <>
      <OrdersKanbanLayout title={title} totalColumns={totalColumns}>
        {!hasAutoAccept && <PendingToAcceptColumn />}
        <CookingColumn hasAutoAccept={hasAutoAccept} />
        <PendingToDeliverColumn />
      </OrdersKanbanLayout>
    </>
  );
}

export default OrdersKanbanPage;
